
(function () {
  'use strict';

  /* ─── STATE ─────────────────────────────────────── */
  var product          = null;
  var selectedVariant  = null;
  var slides           = [];
  var currentSlide     = 0;
  var slideTimer       = null;
  var productURL       = '/products/fly-well-hoodie';
  var hoodieDesigns = {
    Blue: {name: 'Mr Suitcase', image: '//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-mr-suitcase.webp?v=36170228609667908861791765136'},
    Black: {name: 'The Bellhop', image: '//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-bellhop.webp?v=71071934574649350161791765134'}
  };

  /* ─── BUNDLE STATE ───────────────────────────────── */
  var TONIC_HANDLE      = 'flywell';
  var BUNDLE1_PRICE = 0;
  var BUNDLE2_PRICE = 0;
  var HOODIE_ONLY_PRICE = 0;
  var hoodieVariantId   = null;
  var tonicVariantId    = null;
  var hoodiePrice       = 0;
  var tonicPrice        = 0;

  /* ─── FETCH BOTH PRODUCTS ────────────────────────── */
  var tonicProduct = null;
  var bundleProducts = [];
  Promise.all([
    window.FlyWellNative.product('fly-well-hoodie'),
    window.FlyWellNative.product('flywell'),
    window.FlyWellNative.product('hoodie-flywell-pouch'),
    window.FlyWellNative.product('hoodie-2-flywell-pouches')
  ])
  .then(function (results) {
    var p = Object.assign({}, results[0], {variants:results[0].variants.filter(function(v){return !!hoodieDesigns[v.option1];})});
    var tonic = results[1];

    p.media = [{"id":"hoodie-girls-ocean","position":1,"alt":"The girls wearing Mr Suitcase and The Bellhop hoodies by the ocean","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-77e941b6f42887b271d17805.jpg?v=18278731437129142881791764991","width":800,"height":1200,"aspect_ratio":0.6666666666666666,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-77e941b6f42887b271d17805.jpg?v=18278731437129142881791764991","width":800,"height":1200,"aspect_ratio":0.6666666666666666}},{"id":42598229934386,"position":2,"alt":"Blue \u2014 Mr Suitcase hoodie, back print product render","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-mr-suitcase.webp?v=36170228609667908861791765136","width":551,"height":640,"aspect_ratio":0.8609375,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-mr-suitcase.webp?v=36170228609667908861791765136","width":551,"height":640,"aspect_ratio":0.8609375}},{"id":43537000137010,"position":3,"alt":"Black \u2014 The Bellhop hoodie, back print product render","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-bellhop.webp?v=71071934574649350161791765134","width":612,"height":640,"aspect_ratio":0.95625,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-bellhop.webp?v=71071934574649350161791765134","width":612,"height":640,"aspect_ratio":0.95625}},{"id":"hoodie-bellhop-unlimited-miles","position":4,"alt":"Black \u2014 The Bellhop hoodie, Unlimited Miles back print close-up","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-bellhop-unlimited-miles.webp?v=106375963475194929621791765134","width":1152,"height":1536,"aspect_ratio":0.75,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-bellhop-unlimited-miles.webp?v=106375963475194929621791765134","width":1152,"height":1536,"aspect_ratio":0.75}},{"id":"hoodie-photo-03","position":5,"alt":"Mr Suitcase hoodie and FlyWell pouch at the airport gate","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-airport-mr-suitcase.webp?v=176868994967282955831791765133","width":1152,"height":1536,"aspect_ratio":0.75,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-airport-mr-suitcase.webp?v=176868994967282955831791765133","width":1152,"height":1536,"aspect_ratio":0.75}},{"id":"hoodie-photo-04","position":6,"alt":"Mr Suitcase hoodie while boarding a flight","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-boarding-mr-suitcase.webp?v=134009630218319486931791765135","width":1440,"height":1920,"aspect_ratio":0.75,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-boarding-mr-suitcase.webp?v=134009630218319486931791765135","width":1440,"height":1920,"aspect_ratio":0.75}},{"id":"hoodie-studio-blue","position":7,"alt":"Blue \u2014 Mr Suitcase hoodie, back print studio view","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-render-mr-suitcase-blue.webp?v=68383064029777062711791765136","width":1274,"height":1234,"aspect_ratio":1.032414910858995,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-render-mr-suitcase-blue.webp?v=68383064029777062711791765136","width":1274,"height":1234,"aspect_ratio":1.032414910858995}},{"id":"hoodie-lounge-bellhop","position":8,"alt":"Black \u2014 The Bellhop hoodie in an airport lounge","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-lounge-bellhop.webp?v=105797083304647150341791765135","width":1152,"height":1536,"aspect_ratio":0.75,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-lounge-bellhop.webp?v=105797083304647150341791765135","width":1152,"height":1536,"aspect_ratio":0.75}},{"id":"hoodie-photo-05","position":9,"alt":"Blue \u2014 Mr Suitcase hoodie by the ocean","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-ad83762a04e0c6d242d11dca.webp?v=10318225383610864391791765042","width":4128,"height":6192,"aspect_ratio":0.6666666666666666,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-ad83762a04e0c6d242d11dca.webp?v=10318225383610864391791765042","width":4128,"height":6192,"aspect_ratio":0.6666666666666666}},{"id":"hoodie-photo-06","position":10,"alt":"Mr Suitcase hoodie, alternate studio view","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-render-mr-suitcase-studio.webp?v=16677838654158470831791765136","width":1273,"height":1236,"aspect_ratio":1.029935275080906,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-render-mr-suitcase-studio.webp?v=16677838654158470831791765136","width":1273,"height":1236,"aspect_ratio":1.029935275080906}},{"id":"hoodie-photo-07","position":11,"alt":"The Bellhop hoodie at the airport lounge","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-lounge-bellhop-wide.webp?v=133787677534932481581791765135","width":1152,"height":1536,"aspect_ratio":0.75,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-hoodie-lounge-bellhop-wide.webp?v=133787677534932481581791765135","width":1152,"height":1536,"aspect_ratio":0.75}},{"id":"hoodie-photo-08","position":12,"alt":"FlyWell hoodies with luggage, ready to travel","media_type":"image","src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-6674e40e0b27dded86469d75.jpg?v=45526077849711338121791764974","width":1200,"height":800,"aspect_ratio":1.5,"preview_image":{"src":"//drinkflywell.com/cdn/shop/t/49/assets/fw-v22-6674e40e0b27dded86469d75.jpg?v=45526077849711338121791764974","width":1200,"height":800,"aspect_ratio":1.5}}];
    tonicProduct = tonic;
    bundleProducts = results.slice(2);
    product    = p;
    productURL = window.FlyWellNative.url('products/' + p.handle);
    renderProduct(p);

    /* Bundle — pick first available variant of each */
    var hv = (p.variants && p.variants.find(function (v) { return v.available; })) || (p.variants && p.variants[0]);
    var tv = (tonic.variants && tonic.variants.find(function (v) { return v.available && v.option2 === '15'; })) || (tonic.variants && tonic.variants.find(function (v) { return v.option2 === '15'; }));

    if (hv) { hoodieVariantId = hv.id; hoodiePrice = hv.price; }
    if (tv) { tonicVariantId  = tv.id; tonicPrice  = tv.price; }

    renderBundles();
  })
  .catch(function (err) {
    console.warn('[FW] fetch failed:', err);
    setText('fw-product-price', 'See price on product page');
    var loadEl = document.getElementById('fw-bundle-loading');
    var errEl  = document.getElementById('fw-bundle-error');
    if (loadEl) loadEl.style.display = 'none';
    if (errEl)  errEl.style.display  = 'block';
  });

  /* ─── RENDER ─────────────────────────────────────── */
  function renderProduct(p) {
    // Title
    var titleEl = document.getElementById('fw-product-title');
    if (titleEl && p.title) {
      var words = p.title.trim().split(/\s+/);
      var half  = Math.ceil(words.length / 2);
      titleEl.innerHTML = words.slice(0, half).join(' ') + '<br>' + words.slice(half).join(' ');
    }

    // Description (first sentence, strip HTML)
    var descEl = document.getElementById('fw-product-desc');
    if (descEl && p.description) {
      var tmp  = document.createElement('div');
      tmp.innerHTML = p.description;
      var text = (tmp.textContent || tmp.innerText || '').trim();
      var sent = text.split(/\.[\s\n]/)[0].replace(/\s+/g, ' ').trim();
      if (sent) descEl.textContent = sent + '.';
    }

    // First available variant
    var v = firstAvailableVariant(p) || (p.variants && p.variants[0]);
    if (v) {
      selectedVariant = v;
      updatePrice(v);
    }

    // Images
    var images = (p.media && p.media.length) ? p.media : (p.images && p.images.length)
      ? p.images
      : (p.featured_image ? [{ src: p.featured_image, alt: p.title }] : []);
    buildSlideshow(images);

    // Variant selectors
    buildVariants(p);

    // CTA button price
    updateCtaBtn(v);
  }

  function firstAvailableVariant(p) {
    if (!p.variants) return null;
    return p.variants.find(function (v) { return v.available; }) || null;
  }

  /* ─── PRICE ──────────────────────────────────────── */
  function updatePrice(v) {
    if (!v) return;
    updateDesignVisuals(v);

    var price    = v.price;
    var compare  = v.compare_at_price;

    setText('fw-product-price', fmtMoney(price));

    /* Keep hoodie-only bundle card in sync */
    HOODIE_ONLY_PRICE = price;
    hoodiePrice     = price;
    hoodieVariantId = v.id;
    setText('fw-bundle-price', fmtMoney(HOODIE_ONLY_PRICE));
    /* Re-render bundle prices if tonic already loaded */
    if (tonicPrice > 0) renderBundles();

    var compareEl  = document.getElementById('fw-product-compare');
    var badgeEl    = document.getElementById('fw-discount-badge');

    if (compare && compare > price) {
      var pct = Math.round((1 - price / compare) * 100);
      if (compareEl) { compareEl.textContent = fmtMoney(compare); compareEl.style.display = 'inline'; }
      if (badgeEl)   { badgeEl.textContent   = pct + '% OFF';      badgeEl.style.display   = 'inline-flex'; }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (badgeEl)   badgeEl.style.display   = 'none';
    }
  }

  function updateCtaBtn(v) {
    var btn = document.getElementById('fw-cta-btn');
    if (btn && v) btn.textContent = 'Add Hoodie to Cart — ' + fmtMoney(v.price);
  }

  function fmtMoney(cents) {
    if (cents == null) return '';
    return window.FlyWellNative.money(cents);
  }

  function setText(id, txt) {
    var el = document.getElementById(id);
    if (el) el.textContent = txt;
  }

  /* ─── SLIDESHOW ──────────────────────────────────── */
  function buildSlideshow(images) {
    var wrap = document.getElementById('fw-slideshow');
    var dots = document.getElementById('fw-dots');
    if (!wrap) return;

    wrap.innerHTML = '';
    if (dots) dots.innerHTML = '';
    slides = [];
    currentSlide = 0;

    if (!images || !images.length) {
      // grey placeholder
      var ph = document.createElement('div');
      ph.className = 'fw-slide active';
      ph.style.cssText = 'background:#e8e8e8;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;';
      wrap.appendChild(ph);
      slides.push(ph);
      return;
    }

    images.forEach(function (img, i) {
      var slide = document.createElement('div');
      slide.className = 'fw-slide' + (i === 0 ? ' active' : '');
      slide.setAttribute('aria-hidden', String(i !== 0));

      var el   = document.createElement('img');
      el.src   = typeof img === 'string' ? img : (img.src || img.url || '');
      el.alt   = (img && img.alt) ? img.alt : 'FlyWell Hoodie';
      el.loading = i === 0 ? 'eager' : 'lazy';
      el.decoding = 'async';
      if (img.width && img.height) { el.width = img.width; el.height = img.height; }
      if (el.src.indexOf('hoodie-render-') !== -1) slide.classList.add('is-render');
      if (Object.keys(hoodieDesigns).some(function (color) { return el.getAttribute('src') === hoodieDesigns[color].image; })) slide.classList.add('is-product-render');
      if (i === 0) slide.classList.add('is-girls');
      slide.appendChild(el);
      wrap.appendChild(slide);
      slides.push(slide);

      if (dots) {
        var dot = document.createElement('button');
        dot.className   = 'fw-dot' + (i === 0 ? ' active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1) + ': ' + el.alt);
        dot.setAttribute('aria-current', String(i === 0));
        dot.addEventListener('click', (function (idx) {
          return function () { if (slideTimer) clearInterval(slideTimer); goTo(idx); };
        })(i));
        dots.appendChild(dot);
      }
    });

    // Show arrows + auto-play only when > 1 image
    if (slides.length > 1) {
      var prevBtn = document.getElementById('fw-prev');
      var nextBtn = document.getElementById('fw-next');
      if (prevBtn) prevBtn.style.display = 'flex';
      if (nextBtn) nextBtn.style.display = 'flex';
      if (prevBtn) prevBtn.onclick = function () { if (slideTimer) clearInterval(slideTimer); goTo((currentSlide - 1 + slides.length) % slides.length); };
      if (nextBtn) nextBtn.onclick = function () { if (slideTimer) clearInterval(slideTimer); goTo((currentSlide + 1) % slides.length); };

      if (slideTimer) clearInterval(slideTimer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) slideTimer = setInterval(function () {
        goTo((currentSlide + 1) % slides.length);
      }, 5000);
      var touchStart = null;
      wrap.addEventListener('touchstart', function (event) {
        touchStart = {x:event.touches[0].clientX, y:event.touches[0].clientY};
      }, {passive:true});
      wrap.addEventListener('touchend', function (event) {
        if (!touchStart) return;
        var dx = event.changedTouches[0].clientX - touchStart.x;
        var dy = event.changedTouches[0].clientY - touchStart.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          if (slideTimer) clearInterval(slideTimer);
          goTo((currentSlide + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
        }
        touchStart = null;
      }, {passive:true});
    }
  }

  function goTo(idx) {
    if (!slides.length) return;
    slides[currentSlide].classList.remove('active');
    slides[currentSlide].setAttribute('aria-hidden', 'true');
    var allDots = document.querySelectorAll('.fw-dot');
    if (allDots[currentSlide]) { allDots[currentSlide].classList.remove('active'); allDots[currentSlide].setAttribute('aria-current', 'false'); }
    currentSlide = idx;
    slides[currentSlide].classList.add('active');
    slides[currentSlide].setAttribute('aria-hidden', 'false');
    if (allDots[currentSlide]) { allDots[currentSlide].classList.add('active'); allDots[currentSlide].setAttribute('aria-current', 'true'); }
  }

  /* ─── VARIANTS ───────────────────────────────────── */
  function showDesignSlide(variant) {
    var design = hoodieDesigns[variant && variant.option1];
    if (!design || !product) return;
    var index = (product.media || []).findIndex(function (media) { return media.src === design.image; });
    if (index >= 0) goTo(index);
  }

  function getOptionName(opt) {
    if (typeof opt === 'string') return opt;
    if (opt && opt.name) return opt.name;
    return String(opt);
  }

  function updateDesignVisuals(v) {
    var design = hoodieDesigns[v.option1];
    if (!design) return;
    document.querySelectorAll('[data-bundle-hoodie]').forEach(function (img) {
      img.src = design.image;
      img.alt = v.option1 + ' — ' + design.name + ' FlyWell hoodie';
    });
    document.querySelectorAll('[data-bundle-design]').forEach(function (label) {
      label.textContent = design.name + ' · ' + v.option1;
    });
  }

  function updateModalVisual(v) {
    var design = hoodieDesigns[v && v.option1];
    var preview = document.getElementById('fw-modal-preview');
    if (!design || !preview) return;
    var pouches = '';
    for (var i = 0; i < pendingBundleType; i++) {
      pouches += '<img class="fw-bundle-pouch fw-approved-pouch" src="//drinkflywell.com/cdn/shop/t/49/assets/fw-approved-passion-pouch.png?v=32630701197148455801791765053" alt="FlyWell Passion Fruit Tangerine pouch" width="1024" height="1024">';
    }
    preview.innerHTML = '<div class="fw-bundle-art" data-pouch-count="' + pendingBundleType + '"><img class="fw-bundle-hoodie" src="' + design.image + '" alt="' + v.option1 + ' — ' + design.name + ' hoodie" width="640" height="640">' + pouches + '</div>';
  }

  function buildVariantHTML(p, idPrefix) {
    var opts = p.options || [];
    var html = '';
    opts.forEach(function (opt, oi) {
      var label  = oi === 0 ? 'Design' : getOptionName(opt);
      var seen   = {};
      var values = [];
      p.variants.forEach(function (v) {
        var val = v['option' + (oi + 1)];
        if (val && !seen[val]) { seen[val] = true; values.push(val); }
      });
      html += '<div class="fw-variants" data-optgroup="' + idPrefix + '" data-opt="' + oi + '">';
      html += '<span class="fw-variants__label">' + label + '</span>';
      html += '<div class="fw-variants__options' + (oi === 0 ? ' fw-design-options' : '') + '">';
      values.forEach(function (val, vi) {
        var avail = p.variants.some(function (v) {
          return v['option' + (oi + 1)] === val && v.available;
        });
        var isSelected = selectedVariant ? selectedVariant['option' + (oi + 1)] === val : vi === 0;
        var design = oi === 0 ? hoodieDesigns[val] : null;
        var cls = 'fw-variant-btn' + (design ? ' fw-design-btn' : '') +
          (isSelected ? ' selected' : '') +
          (!avail ? ' unavailable' : '');
        var content = design ? '<span class="fw-design-swatch fw-design-swatch--' + val.toLowerCase() + '" aria-hidden="true"></span><span class="fw-design-copy"><strong>' + val + '</strong><span>' + design.name + '</span></span>' : val;
        html += '<button type="button" class="' + cls + '" aria-pressed="' + isSelected + '"' +
          ' data-optgroup="' + idPrefix + '"' +
          ' data-opt="' + oi + '"' +
          ' data-val="' + val.replace(/"/g, '&quot;') + '"' +
          ' onclick="fwPickOption(this)">' + content + '</button>';
      });
      html += '</div></div>';
    });
    return html;
  }

  function buildVariants(p) {
    var container = document.getElementById('fw-variant-container');
    if (!container || !p.variants || p.variants.length <= 1) return;
    container.innerHTML = buildVariantHTML(p, 'hero');
  }

  function resolveVariantFromGroup(groupId) {
    if (!product) return null;
    var chosen = {};
    document.querySelectorAll('.fw-variant-btn.selected[data-optgroup="' + groupId + '"]').forEach(function (b) {
      chosen[parseInt(b.dataset.opt)] = b.dataset.val;
    });
    return product.variants.find(function (v) {
      return Object.keys(chosen).every(function (k) {
        return v['option' + (parseInt(k) + 1)] === chosen[k];
      });
    }) || null;
  }

  window.fwPickOption = function (btn) {
    /* Deselect siblings in the SAME option group + same option index */
    var groupId = btn.dataset.optgroup;
    var optIdx  = btn.dataset.opt;
    document.querySelectorAll('.fw-variant-btn[data-optgroup="' + groupId + '"][data-opt="' + optIdx + '"]').forEach(function (b) {
      b.classList.remove('selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('selected');
    btn.setAttribute('aria-pressed', 'true');

    /* Only update hero state when picking from hero group */
    if (groupId === 'hero') {
      var match = resolveVariantFromGroup('hero');
      if (match) {
        selectedVariant = match;
        hoodieVariantId = match.id;
        updatePrice(match);
        updateCtaBtn(match);
        if (Number(optIdx) === 0) {
          if (slideTimer) clearInterval(slideTimer);
          showDesignSlide(match);
        }
      }
    } else if (groupId === 'modal') {
      updateModalVisual(resolveVariantFromGroup('modal'));
      updateBundleSelection();
    }
  };

  /* ─── ADD TO CART ─────────────────────────────────── */
  window.fwAddToCart = function () {
    var variantId = selectedVariant
      ? selectedVariant.id
      : (product && product.variants && product.variants[0] && product.variants[0].id);

    if (!variantId) {
      showToast('Could not find product. Please refresh.', true);
      return;
    }

    var mainBtn = document.getElementById('fw-atc-btn');
    if (mainBtn) { mainBtn.classList.add('fw-btn--loading'); mainBtn.disabled = true; }

    window.FlyWellNative.add(variantId, 1)
    .then(function (data) {
      if (mainBtn) {
        mainBtn.classList.remove('fw-btn--loading');
        mainBtn.disabled    = false;
        mainBtn.textContent = '✓ Added!';
        setTimeout(function () { mainBtn.textContent = 'Add to Cart'; }, 2600);
      }
      showToast('Added to cart!', false);
      window.FlyWellNative.drawer().catch(function(){});
      refreshCartBubble();
    })
    .catch(function (err) {
      if (mainBtn) { mainBtn.classList.remove('fw-btn--loading'); mainBtn.disabled = false; mainBtn.textContent = 'Add to Cart'; }
      showToast(err.message || 'Something went wrong. Please try again.', true);
    });
  };

  /* ─── BUNDLE RENDER ─────────────────────────────── */
  function renderBundles() {
    if (bundleProducts.length !== 2 || !selectedVariant || !tonicProduct) return;
    var pouch = tonicProduct.variants.find(function (v) {return String(v.id) === String(tonicVariantId);}) || tonicProduct.variants.find(function (v) {return v.available && v.option2 === '15';});
    if (!pouch) return;
    var firstBundle = window.FlyWellNative.resolveBundle(bundleProducts[0], selectedVariant, pouch);
    var secondBundle = window.FlyWellNative.resolveBundle(bundleProducts[1], selectedVariant, pouch);
    BUNDLE1_PRICE = firstBundle ? firstBundle.price : bundleProducts[0].price;
    BUNDLE2_PRICE = secondBundle ? secondBundle.price : bundleProducts[1].price;
    HOODIE_ONLY_PRICE = selectedVariant.price;
    tonicPrice = pouch.price;
    ['fw-b1-btn','fw-b2-btn'].forEach(function(id,index){var button=document.getElementById(id);var v=index ? secondBundle:firstBundle;if(button){button.disabled=!v || !v.available;button.textContent=v && v.available ? 'Get the Bundle':'Out of Stock';}});

    var retail1  = hoodiePrice + tonicPrice;
    var retail2  = hoodiePrice + tonicPrice * 2;
    var save1    = retail1 - BUNDLE1_PRICE;
    var save2    = retail2 - BUNDLE2_PRICE;

    setText('fw-b1-price',   fmtMoney(BUNDLE1_PRICE));
    if (save1 > 0) {
      setText('fw-b1-save',  'Save ' + fmtMoney(save1));
      setText('fw-b1-old',   fmtMoney(retail1) + ' value');
    } else {
      setText('fw-b1-save',  '');
      setText('fw-b1-old',   '');
    }

    setText('fw-b2-price',   fmtMoney(BUNDLE2_PRICE));
    if (save2 > 0) {
      setText('fw-b2-save',  'Save ' + fmtMoney(save2));
      setText('fw-b2-old',   fmtMoney(retail2) + ' value');
    } else {
      setText('fw-b2-save',  '');
      setText('fw-b2-old',   '');
    }

    setText('fw-bundle-price', fmtMoney(HOODIE_ONLY_PRICE));

    var loadEl = document.getElementById('fw-bundle-loading');
    var gridEl = document.getElementById('fw-bundle-grid');
    if (loadEl) loadEl.style.display = 'none';
    if (gridEl) gridEl.style.display = 'grid';
  }

  /* ─── BUNDLE ADD TO CART ─────────────────────────── */
  var pendingBundleType = 0;
  var pendingBundleBtn  = null;
  var pendingBundleLabel = '';

  /* type 0 = hoodie only | 1 = hoodie+1 pouch | 2 = hoodie+2 pouches */
  window.fwBundleAdd = function (type) {
    var btnId = type === 0 ? 'fw-b3-btn' : (type === 1 ? 'fw-b1-btn' : 'fw-b2-btn');
    var btn   = document.getElementById(btnId);
    var label = type === 0 ? 'Add to Cart' : 'Get the Bundle';

    if (!hoodieVariantId && !selectedVariant) {
      showToast('Products still loading, please wait…', true);
      return;
    }

    /* If product has multiple variants, show the modal */
    if (product && product.variants && product.variants.length > 1) {
      pendingBundleType  = type;
      pendingBundleBtn   = btn;
      pendingBundleLabel = label;
      openVariantModal(type);
      return;
    }

    /* Single-variant product — add directly */
    executeBundleAdd(type, btn, label, hoodieVariantId || selectedVariant.id);
  };

  function openVariantModal(type) {
    var overlay  = document.getElementById('fw-modal-overlay');
    var varCont  = document.getElementById('fw-modal-variants');
    var titleEl  = document.getElementById('fw-modal-title');
    var subEl    = document.getElementById('fw-modal-subtitle');
    if (!overlay || !varCont || !product) return;

    var titles = ['Hoodie Only', 'Hoodie + FlyWell Pouch', 'Hoodie + 2 FlyWell Pouches'];
    if (titleEl) titleEl.textContent = titles[type] || 'Select Your Options';
    if (subEl)   subEl.textContent   = type ? 'Choose your design, size & flavor' : 'Choose your design & size';

    varCont.innerHTML = buildVariantHTML(product, 'modal');
    if (type && tonicProduct) {
      var flavors = tonicProduct.variants.filter(function(v){return v.option2 === '15';});
      var flavorGroup = document.createElement('div'); flavorGroup.className='fw-variants';
      var label=document.createElement('label'); label.className='fw-variants__label'; label.htmlFor='fw-bundle-flavor'; label.textContent='FlyWell flavor';
      var select=document.createElement('select'); select.id='fw-bundle-flavor'; select.className='fw-bundle-flavor';
      flavors.forEach(function(v){var option=document.createElement('option');option.value=String(v.id);option.textContent=v.option1+(v.available?'':' — Out of Stock');option.disabled=!v.available;option.selected=String(v.id)===String(tonicVariantId);select.appendChild(option);});
      select.addEventListener('change',function(){tonicVariantId=select.value;updateBundleSelection();});
      flavorGroup.appendChild(label);flavorGroup.appendChild(select);varCont.appendChild(flavorGroup);
      var price=document.createElement('p');price.id='fw-bundle-selection-price';price.setAttribute('aria-live','polite');varCont.appendChild(price);
    }
    updateBundleSelection();

    updateModalVisual(resolveVariantFromGroup('modal'));
    overlay.classList.add('open');
  }


  function updateBundleSelection() {
    var hoodie = resolveVariantFromGroup('modal');
    var confirm = document.getElementById('fw-modal-confirm');
    var price = document.getElementById('fw-bundle-selection-price');
    var flavor = document.getElementById('fw-bundle-flavor');
    if (flavor) tonicVariantId = flavor.value;
    var selected = hoodie;
    if (pendingBundleType && hoodie && tonicProduct) {
      var tonic = tonicProduct.variants.find(function(v){return String(v.id)===String(tonicVariantId);});
      selected = tonic && window.FlyWellNative.resolveBundle(bundleProducts[pendingBundleType-1],hoodie,tonic);
    }
    if (confirm) {confirm.disabled=!selected || !selected.available;confirm.textContent=selected && selected.available ? (pendingBundleType ? 'Add bundle to cart':'Add hoodie to cart') : 'Out of Stock';}
    if (price) price.textContent=selected ? fmtMoney(selected.price):'Unavailable combination';
  }

  function closeVariantModal() {
    var overlay = document.getElementById('fw-modal-overlay');
    if (overlay) overlay.classList.remove('open');
  }

  /* Wire up modal close + confirm */
  document.addEventListener('DOMContentLoaded', function () {
    var closeBtn   = document.getElementById('fw-modal-close');
    var overlay    = document.getElementById('fw-modal-overlay');
    var confirmBtn = document.getElementById('fw-modal-confirm');

    if (closeBtn) closeBtn.addEventListener('click', closeVariantModal);
    if (overlay) overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeVariantModal();
    });
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      var match = resolveVariantFromGroup('modal');
      if (!match) {
        showToast('Please select all options', true);
        return;
      }
      if (!match.available) {
        showToast('This combination is sold out', true);
        return;
      }
      selectedVariant = match;
      updatePrice(match);
      updateCtaBtn(match);
      buildVariants(product);
      if (slideTimer) clearInterval(slideTimer);
      showDesignSlide(match);
      confirmBtn.classList.add('fw-btn--loading');
      confirmBtn.disabled = true;
      closeVariantModal();
      executeBundleAdd(pendingBundleType, pendingBundleBtn, pendingBundleLabel, match.id, confirmBtn);
    });
  });

  function executeBundleAdd(type, btn, label, chosenHoodieId, modalBtn) {
    var items = [{ id: chosenHoodieId, quantity: 1 }];
    if (type >= 1 && tonicVariantId) {
      items.push({ id: tonicVariantId, quantity: type });
    }

    if (btn) { btn.classList.add('fw-btn--loading'); btn.disabled = true; }

    function resetModalBtn() {
      if (modalBtn) { modalBtn.classList.remove('fw-btn--loading'); modalBtn.disabled = false; }
    }

    window.FlyWellNative.addBundle(chosenHoodieId, tonicVariantId, type)
    .then(function () {
      resetModalBtn();
      if (btn) {
        btn.classList.remove('fw-btn--loading');
        btn.disabled    = false;
        btn.textContent = type === 0 ? '✓ Added!' : '✓ Bundle Added!';
        setTimeout(function () { btn.textContent = label; }, 2600);
      }
      showToast(type === 0 ? 'Hoodie added to cart!' : 'Bundle added to cart!', false);
      window.FlyWellNative.drawer().catch(function(){});
      refreshCartBubble();
    })
    .catch(function (err) {
      resetModalBtn();
      if (btn) { btn.classList.remove('fw-btn--loading'); btn.disabled = false; btn.textContent = label; }
      showToast(err.message || 'Something went wrong.', true);
    });
  };

  /* ─── NAVIGATE TO PRODUCT PAGE ───────────────────── */
  window.fwGoToProduct = function () {
    window.location.href = productURL;
  };

  /* ─── REFRESH CART BUBBLE ─────────────────────────── */
  function refreshCartBubble() {
    fetch(window.FlyWellNative.url('cart.js'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Update Dawn / standard theme cart count */
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        bubbles.forEach(function (el) { el.textContent = cart.item_count; });

        /* If bubble didn't exist yet (cart was empty), inject it */
        if (!bubbles.length && cart.item_count > 0) {
          var icon = document.getElementById('cart-icon-bubble');
          if (icon) {
            var div = document.createElement('div');
            div.className = 'cart-count-bubble';
            div.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            icon.appendChild(div);
          }
        }

        /* Fire events for cart drawers / other sections */
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  /* ─── TOAST ──────────────────────────────────────── */
  var toastTimer = null;
  function showToast(msg, isError) {
    var toast  = document.getElementById('fw-toast');
    var msgEl  = document.getElementById('fw-toast-msg');
    if (!toast) return;
    if (msgEl) msgEl.textContent = msg;
    toast.classList.toggle('error', !!isError);

    /* Force reflow so animation triggers even on repeat calls */
    toast.classList.remove('show');
    void toast.offsetWidth;
    toast.classList.add('show');

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, 3200);
  }

})();

